<template>
  <v-container fluid>
    <v-card outlined>
      <v-data-table
        :headers="headers"
        :items="items"
        :items-per-page="-1"
        sort-by="date"
      >
        <template v-slot:item.date="{ item }">{{
          item.date | formatDate
        }}</template>
        <template v-slot:item.actions="{ item }">
          <v-row>
            <v-btn icon small class="mx-0" @click="onDetails(item)">
              <v-icon small color="cyan">mdi-file-find</v-icon>
            </v-btn>
            <confirmation-dialog @onConfirm="onRemoveAccept(item)">
              <v-btn icon small class="mx-0">
                <v-icon small color="pink">mdi-delete</v-icon>
              </v-btn>
              <template slot="message">This will remove Increment</template>
            </confirmation-dialog>
          </v-row>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
import { sortByDate } from "../../../../../helpers";
import ConfirmationDialog from "../../../shared/ConfirmationDialog";
export default {
  name: "increments-table",

  props: {
    value: {
      type: Array,
      default: () => [],
    },
  },

  components: { ConfirmationDialog },

  data() {
    return {
      debug: false,
      headers: [
        {
          text: "Ref",
          value: "reference",
          name: "reference",
        },
        {
          text: "Date",
          value: "date",
          name: "date",
          sort: sortByDate,
        },
        {
          text: "Min Pax",
          value: "minPax",
          name: "minPax",
        },
        {
          text: "Max Pax",
          value: "maxPax",
          name: "maxPax",
        },
        {
          text: "Actions",
          value: "actions",
          name: "actions",
        },
      ],
    };
  },

  computed: {
    items() {
      return [...this.value];
    },
  },

  methods: {
    onDetails(item) {
      this.$emit("details", item);
    },
    onRemoveAccept(item) {
      this.$emit("delete", item);
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/templates/builder/increments/IncrementsTable.vue